import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            // Navigation
            home: 'Home',
            aboutHeader: 'About',
            partners: 'Partners',
            contact: 'Contact',
            architects: 'Architects',
            builders: 'Builders',
            marketplace: 'Marketplace',
            // About Page
            about: {
                title: 'About PlanNbuild',
                description: 'PlanNbuild is a revolutionary platform that connects property owners with trusted construction professionals in Cape Verde. Our mission is to simplify and secure the construction process while ensuring the highest quality standards.',
                features: {
                    mission: {
                        title: 'Our Mission',
                        description: 'To transform the construction industry in Cape Verde by providing a transparent, efficient, and secure platform that connects property owners with verified professionals.'
                    },
                    vision: {
                        title: 'Our Vision',
                        description: 'To become the leading construction management platform in Cape Verde, setting new standards for quality, transparency, and customer satisfaction.'
                    },
                    values: {
                        title: 'Our Values',
                        description: 'We are committed to transparency, quality, innovation, and customer satisfaction. We believe in building trust through reliable service and continuous improvement.'
                    }
                }
            },
            // Banner
            banner: {
                build: 'Build',
                yourDreamHome: 'Your Dream Home',
                in: 'In',
                capeVerde: 'Cape Verde',
                startProject: 'Start Your Project',
                exploreNow: 'Explore Now',
                abroad: 'Abroad!'
            },
            features: {
                trustedNetwork: 'Trusted Professional Network',
                architectTeams: 'Curated architect teams.',
                verifiedCompanies: 'Verified construction companies and local inspectors.',
                endToEnd: 'End-to-End',
                visibility: 'Visibility',
                designApprovals: 'From design approvals to milestone payments, see everything in one place.',
                realTimeReports: 'Real-time inspector reports and transparent issue tracking.',
                paymentProtection: 'Payment Protection',
                milestonePayments: 'Milestone-based payments held in a secure build account.',
                fundsReleased: 'Funds released only after certified architect approval.',
                buildYourDream: 'Build your Dream without Stress',
                inspectorLogs: 'Inspector Logs',
                seeIncidentReports: 'See incident reports and resolutions in real time',
                legalOversight: 'Legal Oversight',
                allContractsCertified: 'All contracts and milestone proofs stored and certified',
                digitalDocumentVault: 'Digital Document Vault',
                securelyStorePlans: 'Securely store and access all architectural plans, contracts, permits, incident reports.',
                projectDashboard: 'Project Dashboard',
                viewBuildStatus: '360° view of your build status and documents',
                materialMarketplace: 'Material Marketplace',
                orderFromSuppliers: 'Order from vetted suppliers, B2B & B2C',
                communicationHub: 'Communication Hub',
                keepMessagesDecisions: 'Keep all messages, revisions & decisions in one place'
            },
            offerings: {
                title: 'Build your Dream without Stress',
                createProject: 'Create Your Project',
                description1: 'Begin by registering on PlanNbuild and creating a project brief. You\'ll be guided through questions about your plot location, preferred architectural style, size of your home, number of floors, and desired amenities.',
                receiveBuilderOffers: 'Receive Builder Offers',
                description2: 'Construction begins on-site. Your dedicated inspector visits at least every 48 hours to monitor progress, flag defects, and ensure compliance with approved plans. Any issues are logged as incidents in your dashboard and visible to all parties. You can message directly with your team at any time.',
                milestoneBasedPayments: 'Milestone-Based Payments',
                description3: 'You deposit the full build amount into a secure, project-specific bank account. Payments are only released when a milestone is officially completed. Milestones include foundation, structure, roofing, etc. Each payment is triggered only when your architect provides an attested certificate of completion, uploaded directly into the platform.',
                getConstructionPlan: 'Get your construction plan',
                description4: 'Once hired, your architect team collaborates (remotely and locally) to create your complete house design: floor plans, 3D renderings, construction specs, and legal documents. You\'ll review and approve designs through your PlanNbuild dashboard, with full feedback tools and version control.',
                selectArchitectTeam: 'Select your architect team',
                description6: 'Browse curated teams consisting of architects with international design sensibility, local architects for local code compliance, and a licensed on-site inspector. Review their profiles, past work, ratings, and availability, then select your ideal team.',
                constructionInspectorOversight: 'Construction & Inspector Oversight',
                description5: 'Construction begins on-site. Your dedicated inspector visits at least every 48 hours to monitor progress, flag defects, and ensure compliance with approved plans. Any issues are logged as incidents in your dashboard and visible to all parties. You can message directly with your team at any time.',
                milestoneBasedPayments: 'Milestone-Based Payments',
                description4: 'You deposit the full build amount into a secure, project-specific bank account. Payments are only released when a milestone is officially completed. Milestones include foundation, structure, roofing, etc. Each payment is triggered only when your architect provides an attested certificate of completion, uploaded directly into the platform.',
                getConstructionPlan: 'Get your construction plan',
                description3: 'Once hired, your architect team collaborates (remotely and locally) to create your complete house design: floor plans, 3D renderings, construction specs, and legal documents. You\'ll review and approve designs through your PlanNbuild dashboard, with full feedback tools and version control.',
                selectArchitectTeam: 'Select your architect team',
            },
            slider: {
                title1: 'Create Your Project',
                description1: 'Begin by registering on PlanNbuild and creating a project brief. You\'ll be guided through questions about your plot location, preferred architectural style, size of your home, number of floors, and desired amenities.',
                title2: 'Receive Builder Offers',
                description2: 'When the plans are finalized, verified local construction companies are invited to bid on your project. They provide detailed proposals with pricing, build phases, and estimated timelines. You can compare offers side by side and award the project to your chosen contractor.',
                title3: 'Construction & Inspector Oversight',
                description3: 'Construction begins on-site. Your dedicated inspector visits at least every 48 hours to monitor progress, flag defects, and ensure compliance with approved plans. Any issues are logged as incidents in your dashboard and visible to all parties. You can message directly with your team at any time.',
                title4: 'Milestone-Based Payments',
                description4: 'You deposit the full build amount into a secure, project-specific bank account. Payments are only released when a milestone is officially completed. Milestones include foundation, structure, roofing, etc. Each payment is triggered only when your architect provides an attested certificate of completion, uploaded directly into the platform.',
                title5: 'Get your construction plan',
                description5: 'Once hired, your architect team collaborates (remotely and locally) to create your complete house design: floor plans, 3D renderings, construction specs, and legal documents. You\'ll review and approve designs through your PlanNbuild dashboard, with full feedback tools and version control.',
                title6: 'Select your architect team',
                description6: 'Browse curated teams consisting of a European architect (for international design sensibility), a Cape Verdean architect (for local code compliance), and a licensed on-island inspector. Review their profiles, past work, ratings, and availability — then select your ideal team.'
            },
            footer: {
                about: 'About',
                howItWorks: 'How It Works',
                termsPrivacy: 'Terms & Privacy',
                contactSupport: 'Contact Support',
                createdWith: 'Created with ❤️ by',
                followUsOn: 'Follow us on'
            },
            list: 'List',
            searchWithCompanyName: 'Search with company name',
            companyInformation: 'Company Information',
            email: 'Email',
            experience: 'Experience',
            website: 'Website',
            url: 'URL',
            about: 'About',
            bio: 'Bio',
            specialties: 'Specialties',
            active: 'Active',
            inactive: 'Inactive',
            staffAccounts: 'Staff Accounts',
            phone: 'Phone',
            status: 'Status',
            loading: 'Loading',
            loadingDescription: 'Please wait while we fetch the company details...',
            error: 'Error',
            retry: 'Retry',
            noStaffAccounts: 'No staff accounts found',
            noStaffAccountsDescription: 'This company has not added any staff members yet.',
            noResultFound: "No result found",
        }
    },
    fr: {
        translation: {
            // Navigation
            home: 'Accueil',
            aboutHeader: 'À propos',
            partners: 'Partenaires',
            contact: 'Contact',
            architects: 'Architectes',
            builders: 'Constructeurs',
            marketplace: 'Marché',
            // About Page
            about: {
                title: 'À propos de PlanNbuild',
                description: 'PlanNbuild est une plateforme révolutionnaire qui connecte les propriétaires avec des professionnels de la construction de confiance au Cap-Vert. Notre mission est de simplifier et sécuriser le processus de construction tout en garantissant les plus hauts standards de qualité.',
                features: {
                    mission: {
                        title: 'Notre Mission',
                        description: 'Transformer l\'industrie de la construction au Cap-Vert en fournissant une plateforme transparente, efficace et sécurisée qui connecte les propriétaires avec des professionnels vérifiés.'
                    },
                    vision: {
                        title: 'Notre Vision',
                        description: 'Devenir la plateforme leader de gestion de la construction au Cap-Vert, établissant de nouvelles normes pour la qualité, la transparence et la satisfaction client.'
                    },
                    values: {
                        title: 'Nos Valeurs',
                        description: 'Nous nous engageons pour la transparence, la qualité, l\'innovation et la satisfaction client. Nous croyons en la construction de la confiance à travers un service fiable et une amélioration continue.'
                    }
                }
            },
            // Banner
            banner: {
                build: 'Construisez',
                yourDreamHome: 'Votre Maison de Rêve',
                in: 'à',
                capeVerde: 'Cap-Vert',
                startProject: 'Démarrer Votre Projet',
                exploreNow: 'Explorer Maintenant',
                abroad: 'À l\'étranger !'
            },
            features: {
                trustedNetwork: 'Réseau Professionnel de Confiance',
                architectTeams: 'Équipes d\'architectes sélectionnées.',
                verifiedCompanies: 'Entreprises de construction vérifiées et inspecteurs locaux.',
                endToEnd: 'Visibilité',
                visibility: 'de Bout en Bout',
                designApprovals: 'Des approbations de conception aux paiements par étapes, tout est visible en un seul endroit.',
                realTimeReports: 'Rapports d\'inspection en temps réel et suivi transparent des problèmes.',
                paymentProtection: 'Protection des Paiements',
                milestonePayments: 'Paiements par étapes sécurisés dans un compte de construction.',
                fundsReleased: 'Les fonds sont libérés uniquement après approbation certifiée par l\'architecte.',
                buildYourDream: 'Construisez Votre Rêve Sans Stress',
                inspectorLogs: 'Rapports d\'inspection',
                seeIncidentReports: 'Voir les rapports d\'incident et les résolutions en temps réel',
                legalOversight: 'Contrôle juridique',
                allContractsCertified: 'Tous les contrats et preuves de mijlestone stockés et certifiés',
                digitalDocumentVault: 'Dépôt de documents numériques',
                securelyStorePlans: 'Stockez et accédez à tous les plans architecturaux, contrats, permis, rapports d\'incident.',
                projectDashboard: 'Tableau de bord du projet',
                viewBuildStatus: 'Vue 360° de l\'état de votre construction et de vos documents',
                materialMarketplace: 'Marché des matériaux',
                orderFromSuppliers: 'Commandez auprès de fournisseurs vérifiés, B2B & B2C',
                communicationHub: 'Hub de communication',
                keepMessagesDecisions: 'Gardez toutes les messages, révisions et décisions en un seul endroit'
            },
            offerings: {
                title: 'Construisez Votre Rêve Sans Stress',
                createProject: 'Créez Votre Projet',
                description1: 'Commencez par vous inscrire sur PlanNbuild et créez un brief de projet. Vous serez guidé à travers des questions sur l\'emplacement de votre terrain, le style architectural préféré, la taille de votre maison, le nombre d\'étages et les équipements souhaités.',
                receiveBuilderOffers: 'Recevez des Offres de Constructeurs',
                description2: 'Lorsque les plans sont finalisés, des entreprises de construction locales vérifiées sont invitées à soumissionner pour votre projet. Elles fournissent des propositions détaillées avec prix, phases de construction et délais estimés. Vous pouvez comparer les offres côte à côte et attribuer le projet à l\'entrepreneur de votre choix.',
                constructionInspectorOversight: 'Construction et Supervision par l\'Inspecteur',
                description3: 'La construction commence sur site. Votre inspecteur dédié visite au moins toutes les 48 heures pour surveiller les progrès, signaler les défauts et assurer la conformité avec les plans approuvés. Tout problème est enregistré comme incident dans votre tableau de bord et visible par toutes les parties. Vous pouvez communiquer directement avec votre équipe à tout moment.',
                milestoneBasedPayments: 'Paiements par Étapes',
                description4: 'Vous déposez le montant total de la construction dans un compte bancaire sécurisé spécifique au projet. Les paiements ne sont libérés que lorsqu\'une étape est officiellement terminée. Les étapes comprennent les fondations, la structure, la toiture, etc. Chaque paiement est déclenché uniquement lorsque votre architecte fournit un certificat attesté d\'achèvement, téléchargé directement dans la plateforme.',
                getConstructionPlan: 'Obtenez votre plan de construction',
                description5: 'Une fois engagée, votre équipe d\'architectes collabore (à distance et localement) pour créer votre conception complète de maison : plans d\'étage, rendus 3D, spécifications de construction et documents légaux. Vous examinerez et approuverez les conceptions via votre tableau de bord PlanNbuild, avec des outils de feedback complets et un contrôle de version.',
                selectArchitectTeam: 'Sélectionnez votre équipe d\'architectes',
                description6: 'Parcourez des équipes sélectionnées composées d\'un architecte européen (pour la sensibilité design internationale), d\'un architecte cap-verdien (pour la conformité aux codes locaux) et d\'un inspecteur agréé sur l\'île. Examinez leurs profils, travaux antérieurs, évaluations et disponibilité — puis sélectionnez votre équipe idéale.'
            },
            slider: {
                title1: 'Créez Votre Projet',
                description1: 'Commencez par vous inscrire sur PlanNbuild et créez un brief de projet. Vous serez guidé à travers des questions sur l\'emplacement de votre terrain, le style architectural préféré, la taille de votre maison, le nombre d\'étages et les équipements souhaités.',
                title2: 'Recevez des Offres de Constructeurs',
                description2: 'Lorsque les plans sont finalisés, des entreprises de construction locales vérifiées sont invitées à soumissionner pour votre projet. Elles fournissent des propositions détaillées avec prix, phases de construction et délais estimés. Vous pouvez comparer les offres côte à côte et attribuer le projet à l\'entrepreneur de votre choix.',
                title3: 'Construction et Supervision par l\'Inspecteur',
                description3: 'La construction commence sur site. Votre inspecteur dédié visite au moins toutes les 48 heures pour surveiller les progrès, signaler les défauts et assurer la conformité avec les plans approuvés. Tout problème est enregistré comme incident dans votre tableau de bord et visible par toutes les parties. Vous pouvez communiquer directement avec votre équipe à tout moment.',
                title4: 'Paiements par Étapes',
                description4: 'Vous déposez le montant total de la construction dans un compte bancaire sécurisé spécifique au projet. Les paiements ne sont libérés que lorsqu\'une étape est officiellement terminée. Les étapes comprennent les fondations, la structure, la toiture, etc. Chaque paiement est déclenché uniquement lorsque votre architecte fournit un certificat attesté d\'achèvement, téléchargé directement dans la plateforme.',
                title5: 'Obtenez votre plan de construction',
                description5: 'Une fois engagée, votre équipe d\'architectes collabore (à distance et localement) pour créer votre conception complète de maison : plans d\'étage, rendus 3D, spécifications de construction et documents légaux. Vous examinerez et approuverez les conceptions via votre tableau de bord PlanNbuild, avec des outils de feedback complets et un contrôle de version.',
                title6: 'Sélectionnez votre équipe d\'architectes',
                description6: 'Parcourez des équipes sélectionnées avec soin, composées d\'architectes internationaux, d\'architectes locaux pour le respect des normes locales et d\'un inspecteur de chantier agréé. Consultez leurs profils, leurs réalisations, leurs évaluations et leurs disponibilités, puis sélectionnez l\'équipe idéale.'
            },
            footer: {
                about: 'À propos',
                howItWorks: 'Comment ça marche',
                termsPrivacy: 'Conditions d\'utilisation & Confidentialité',
                contactSupport: 'Contactez le support',
                createdWith: 'Créé avec ❤️ par',
                followUsOn: 'Suivez-nous sur'
            },
            list: 'Liste',
            searchWithCompanyName: 'Zoek met bedrijfsnaam',
            companyInformation: 'Bedrijfsinformatie',
            email: 'E-mail',
            experience: 'Ervaring',
            website: 'Website',
            url: 'URL',
            about: 'Over',
            bio: 'Bio',
            specialties: 'Specialties',
            active: 'Active',
            inactive: 'Inactive',
            staffAccounts: 'Comptes du Personnel',
            phone: 'Téléphone',
            status: 'Statut',
            loading: 'Chargement',
            loadingDescription: 'Veuillez patienter pendant que nous récupérons les détails de l\'entreprise...',
            error: 'Erreur',
            retry: 'Réessayer',
            noStaffAccounts: 'Aucun compte de personnel trouvé',
            noStaffAccountsDescription: 'Cette entreprise n\'a pas encore ajouté de membres du personnel.',
            noResultFound: "Geen resultaten gevonden",
        }
    },
    nl: {
        translation: {
            // Navigation
            home: 'Home',
            aboutHeader: 'Over ons',
            partners: 'Partners',
            contact: 'Contact',
            architects: 'Architecten',
            builders: 'Bouwers',
            marketplace: 'Marktplaats',
            // About Page
            about: {
                title: 'Over PlanNbuild',
                description: 'PlanNbuild is een revolutionair platform dat eigenaren verbindt met vertrouwde bouwprofessionals in Kaapverdië. Onze missie is om het bouwproces te vereenvoudigen en te beveiligen terwijl we de hoogste kwaliteitsstandaarden garanderen.',
                features: {
                    mission: {
                        title: 'Onze Missie',
                        description: 'De bouwsector in Kaapverdië transformeren door een transparant, efficiënt en veilig platform te bieden dat eigenaren verbindt met geverifieerde professionals.'
                    },
                    vision: {
                        title: 'Onze Visie',
                        description: 'De toonaangevende bouwmanagementplatform in Kaapverdië worden, nieuwe normen zetten voor kwaliteit, transparantie en klanttevredenheid.'
                    },
                    values: {
                        title: 'Onze Waarden',
                        description: 'We zetten ons in voor transparantie, kwaliteit, innovatie en klanttevredenheid. We geloven in het opbouwen van vertrouwen door betrouwbare service en continue verbetering.'
                    }
                }
            },
            // Banner
            banner: {
                build: 'Bouw',
                yourDreamHome: 'Uw Droomhuis',
                in: 'in',
                capeVerde: 'Kaapverdië',
                startProject: 'Start Uw Project',
                exploreNow: 'Nu Ontdekken',
                abroad: 'In het buitenland !'
            },
            features: {
                trustedNetwork: 'Vertrouwd Professioneel Netwerk',
                architectTeams: 'Geselecteerde architectenteams.',
                verifiedCompanies: 'Geverifieerde bouwbedrijven en lokale inspecteurs.',
                endToEnd: 'End-to-End',
                visibility: 'Zichtbaarheid',
                designApprovals: 'Van ontwerpgoedkeuringen tot mijlpaalbetalingen, alles op één plek bekijken.',
                realTimeReports: 'Realtime inspectierapporten en transparante probleemopvolging.',
                paymentProtection: 'Betalingsbescherming',
                milestonePayments: 'Mijlpaalgebaseerde betalingen veilig in een bouwrekening.',
                fundsReleased: 'Gelden worden alleen vrijgegeven na gecertificeerde architectgoedkeuring.',
                buildYourDream: 'Bouw Uw Droom Zonder Stress',
                inspectorLogs: 'Inspecteur Logboeken',
                seeIncidentReports: 'Zie incidentrapporten en oplossingen in real time',
                legalOversight: 'Juridische Toezicht',
                allContractsCertified: 'Alle contracten en mijlestonebewijzen opgeslagen en gecertificeerd',
                digitalDocumentVault: 'Digitale Documentenopslag',
                securelyStorePlans: 'Beveilig opslaan en toegang tot alle architectonische plannen, contracten, toestemmingen, incidentrapporten.',
                projectDashboard: 'Project Dashboard',
                viewBuildStatus: '360° overzicht van uw bouwstatus en documenten',
                materialMarketplace: 'Materiaalmarktplaats',
                orderFromSuppliers: 'Bestel van geverifieerde leveranciers, B2B & B2C',
                communicationHub: 'Communicatiehub',
                keepMessagesDecisions: 'Houd alle berichten, revisies en beslissingen op één plek'
            },
            offerings: {
                title: 'Bouw Uw Droom Zonder Stress',
                createProject: 'Maak Uw Project',
                description1: 'Begin met registreren op PlanNbuild en maak een projectbrief. U wordt begeleid door vragen over uw perceellocatie, voorkeursarchitectuurstijl, grootte van uw huis, aantal verdiepingen en gewenste voorzieningen.',
                receiveBuilderOffers: 'Ontvang Aannemer Aanbiedingen',
                description2: 'Wanneer de plannen zijn afgerond, worden geverifieerde lokale bouwbedrijven uitgenodigd om te bieden op uw project. Ze bieden gedetailleerde voorstellen met prijzen, bouwfases en geschatte tijdlijnen. U kunt aanbiedingen naast elkaar vergelijken en het project toewijzen aan uw gekozen aannemer.',
                constructionInspectorOversight: 'Bouw & Inspecteur Toezicht',
                description3: 'De bouw begint op locatie. Uw toegewijde inspecteur bezoekt ten minste elke 48 uur om de voortgang te monitoren, gebreken te signaleren en de naleving van goedgekeurde plannen te waarborgen. Eventuele problemen worden geregistreerd als incidenten in uw dashboard en zichtbaar voor alle partijen. U kunt op elk moment direct berichten met uw team.',
                milestoneBasedPayments: 'Mijlpaalgebaseerde Betalingen',
                description4: 'U stort het volledige bouwbedrag in een veilige, projectspecifieke bankrekening. Betalingen worden alleen vrijgegeven wanneer een mijlpaal officieel is voltooid. Mijlpalen omvatten fundering, structuur, dak, etc. Elke betaling wordt alleen geactiveerd wanneer uw architect een gewaarmerkt voltooiingscertificaat verstrekt, direct geüpload in het platform.',
                getConstructionPlan: 'Krijg uw bouwplan',
                description5: 'Na indienstneming werkt uw architectenteam samen (op afstand en lokaal) om uw complete huisontwerp te maken: plattegronden, 3D-renders, bouwspecificaties en juridische documenten. U beoordeelt en keurt ontwerpen goed via uw PlanNbuild dashboard, met volledige feedbacktools en versiebeheer.',
                selectArchitectTeam: 'Selecteer uw architectenteam',
                description6: 'Blader door geselecteerde teams bestaande uit architecten met internationale designsensitiviteit, architecten locaux pour le respect des normes locales et d\'un inspecteur de chantier agréé. Bekijk hun profilen, eerdere werkzaamheden, beoordelingen en beschikbaarheid — selecteer vervolgens uw ideale team.'
            },
            slider: {
                title1: 'Maak Uw Project',
                description1: 'Begin met registreren op PlanNbuild en maak een projectbrief. U wordt begeleid door vragen over uw perceellocatie, voorkeursarchitectuurstijl, grootte van uw huis, aantal verdiepingen en gewenste voorzieningen.',
                title2: 'Ontvang Aannemer Aanbiedingen',
                description2: 'Wanneer de plannen zijn afgerond, worden geverifieerde lokale bouwbedrijven uitgenodigd om te bieden op uw project. Ze bieden gedetailleerde voorstellen met prijzen, bouwfases en geschatte tijdlijnen. U kunt aanbiedingen naast elkaar vergelijken en het project toewijzen aan uw gekozen aannemer.',
                title3: 'Bouw & Inspecteur Toezicht',
                description3: 'De bouw begint op locatie. Uw toegewijde inspecteur bezoekt ten minste elke 48 uur om de voortgang te monitoren, gebreken te signaleren en de naleving van goedgekeurde plannen te waarborgen. Eventuele problemen worden geregistreerd als incidenten in uw dashboard en zichtbaar voor alle partijen. U kunt op elk moment direct berichten met uw team.',
                title4: 'Mijlpaalgebaseerde Betalingen',
                description4: 'U stort het volledige bouwbedrag in een veilige, projectspecifieke bankrekening. Betalingen worden alleen vrijgegeven wanneer een mijlpaal officieel is voltooid. Mijlpalen omvatten fundering, structuur, dak, etc. Elke betaling wordt alleen geactiveerd wanneer uw architect een gewaarmerkt voltooiingscertificaat verstrekt, direct geüpload in het platform.',
                title5: 'Krijg uw bouwplan',
                description5: 'Na indienstneming werkt uw architectenteam samen (op afstand en lokaal) om uw complete huisontwerp te maken: plattegronden, 3D-renders, bouwspecificaties en juridische documenten. U beoordeelt en keurt ontwerpen goed via uw PlanNbuild dashboard, met volledige feedbacktools en versiebeheer.',
                title6: 'Selecteer uw architectenteam',
                description6: 'Blader door geselecteerde teams bestaande uit architecten met internationale designsensitiviteit, architecten locaux pour le respect des normes locales et d\'un inspecteur de chantier agréé. Bekijk hun profilen, eerdere werkzaamheden, beoordelingen en beschikbaarheid — selecteer vervolgens uw ideale team.'
            },
            footer: {
                about: 'Over ons',
                howItWorks: 'Hoe het werkt',
                termsPrivacy: 'Voorwaarden & Privacy',
                contactSupport: 'Contacteer Support',
                createdWith: 'Gemaakt met ❤️ door',
                followUsOn: 'Volg ons op'
            },
            list: 'Lijst',
            searchWithCompanyName: 'Zoek met bedrijfsnaam',
            companyInformation: 'Bedrijfsinformatie',
            email: 'E-mail',
            experience: 'Ervaring',
            website: 'Website',
            url: 'URL',
            about: 'Over',
            bio: 'Bio',
            specialties: 'Specialties',
            active: 'Active',
            inactive: 'Inactive',
            staffAccounts: 'Personeelsaccounts',
            phone: 'Telefoon',
            status: 'Status',
            loading: 'Laden',
            loadingDescription: 'Even geduld terwijl we de bedrijfsgegevens ophalen...',
            error: 'Fout',
            retry: 'Opnieuw proberen',
            noStaffAccounts: 'Geen personeelsaccounts gevonden',
            noStaffAccountsDescription: 'Dit bedrijf heeft nog geen personeelsleden toegevoegd.',
            noResultFound: "Geen resultaten gevonden",
        }
    },
    pt: {
        translation: {
            // Navigation
            home: 'Início',
            aboutHeader: 'Sobre',
            partners: 'Parceiros',
            contact: 'Contato',
            architects: 'Arquitetos',
            builders: 'Construtores',
            marketplace: 'Mercado',
            // About Page
            about: {
                title: 'Sobre o PlanNbuild',
                description: 'O PlanNbuild é uma plataforma revolucionária que conecta proprietários com profissionais de construção confiáveis em Cabo Verde. Nossa missão é simplificar e garantir o processo de construção enquanto mantemos os mais altos padrões de qualidade.',
                features: {
                    mission: {
                        title: 'Nossa Missão',
                        description: 'Transformar a indústria da construção em Cabo Verde fornecendo uma plataforma transparente, eficiente e segura que conecta proprietários com profissionais verificados.'
                    },
                    vision: {
                        title: 'Nossa Visão',
                        description: 'Tornar-se a principal plataforma de gerenciamento de construção em Cabo Verde, estabelecendo novos padrões para qualidade, transparência e satisfação do cliente.'
                    },
                    values: {
                        title: 'Nossos Valores',
                        description: 'Estamos comprometidos com transparência, qualidade, inovação e satisfação do cliente. Acreditamos em construir confiança através de serviço confiável e melhoria contínua.'
                    }
                }
            },
            // Banner
            banner: {
                build: 'Construa',
                yourDreamHome: 'Sua Casa dos Sonhos',
                in: 'em',
                capeVerde: 'Cabo Verde',
                startProject: 'Inicie Seu Projeto',
                exploreNow: 'Explore Agora',
                abroad: 'No exterior !'
            },
            features: {
                trustedNetwork: 'Rede Profissional Confiável',
                architectTeams: 'Equipes de arquitetos selecionadas.',
                verifiedCompanies: 'Empresas de construção verificadas e inspetores locais.',
                endToEnd: 'Visibilidade',
                visibility: 'de Ponta a Ponta',
                designApprovals: 'Das aprovações de design aos pagamentos por etapas, veja tudo em um só lugar.',
                realTimeReports: 'Relatórios de inspeção em tempo real e acompanhamento transparente de problemas.',
                paymentProtection: 'Proteção de Pagamento',
                milestonePayments: 'Pagamentos por etapas mantidos em uma conta de construção segura.',
                fundsReleased: 'Fundos liberados apenas após aprovação certificada pelo arquiteto.',
                buildYourDream: 'Construa Seu Sonho Sem Estresse',
                inspectorLogs: 'Relatórios de Inspetores',
                seeIncidentReports: 'Veja relatórios de incidentes e resoluções em tempo real',
                legalOversight: 'Supervisão Legal',
                allContractsCertified: 'Todos os contratos e provas de mijlestone armazenados e certificados',
                digitalDocumentVault: 'Cofre Digital de Documentos',
                securelyStorePlans: 'Armazene e acesse todos os planos arquitetônicos, contratos, permissões, relatórios de incidentes.',
                projectDashboard: 'Painel de Projeto',
                viewBuildStatus: 'Visualização 360° da sua construção e documentos',
                materialMarketplace: 'Mercado de Materiais',
                orderFromSuppliers: 'Compre de fornecedores verificados, B2B & B2C',
                communicationHub: 'Hub de Comunicação',
                keepMessagesDecisions: 'Mantenha todos os mensagens, revisões e decisões em um só lugar'
            },
            offerings: {
                title: 'Construa Seu Sonho Sem Estresse',
                createProject: 'Crie Seu Projeto',
                description1: 'Comece registrando-se no PlanNbuild e criando um brief do projeto. Você será guiado por perguntas sobre a localização do seu terreno, estilo arquitetônico preferido, tamanho da sua casa, número de andares e comodidades desejadas.',
                receiveBuilderOffers: 'Receba Ofertas de Construtores',
                description2: 'Quando os planos forem finalizados, empresas de construção locais verificadas são convidadas a licitar seu projeto. Elas fornecem propostas detalhadas com preços, fases de construção e cronogramas estimados. Você pode comparar ofertas lado a lado e atribuir o projeto ao empreiteiro escolhido.',
                constructionInspectorOversight: 'Construção e Supervisão do Inspetor',
                description3: 'A construção começa no local. Seu inspetor dedicado visita pelo menos a cada 48 horas para monitorar o progresso, sinalizar defeitos e garantir conformidade com os planos aprovados. Qualquer problema é registrado como incidente em seu painel e visível para todas as partes. Você pode enviar mensagens diretamente com sua equipe a qualquer momento.',
                milestoneBasedPayments: 'Pagamentos Baseados em Etapas',
                description4: 'Você deposita o valor total da construção em uma conta bancária segura específica do projeto. Os pagamentos são liberados apenas quando uma etapa é oficialmente concluída. As etapas incluem fundação, estrutura, telhado, etc. Cada pagamento é acionado apenas quando seu arquiteto fornece um certificado atestado de conclusão, carregado diretamente na plataforma.',
                getConstructionPlan: 'Obtenha seu plano de construção',
                description5: 'Uma vez contratada, sua equipe de arquitetos colabora (remotamente e localmente) para criar seu design completo da casa: plantas baixas, renderizações 3D, especificações de construção e documentos legais. Você revisará e aprovará designs através do seu painel PlanNbuild, com ferramentas completas de feedback e controle de versão.',
                selectArchitectTeam: 'Selecione sua equipe de arquitetos',
                description6: 'Navegue por equipes selecionadas consistindo de um arquiteto europeu (para sensibilidade de design internacional), um arquiteto cabo-verdiano (para conformidade com códigos locais) e um inspetor licenciado na ilha. Revise seus perfis, trabalhos anteriores, avaliações e disponibilidade — então selecione sua equipe ideal.'
            },
            slider: {
                title1: 'Crie Seu Projeto',
                description1: 'Comece registrando-se no PlanNbuild e criando um brief do projeto. Você será guiado por perguntas sobre a localização do seu terreno, estilo arquitetônico preferido, tamanho da sua casa, número de andares e comodidades desejadas.',
                title2: 'Receba Ofertas de Construtores',
                description2: 'Quando os planos forem finalizados, empresas de construção locais verificadas são convidadas a licitar seu projeto. Elas fornecem propostas detalhadas com preços, fases de construção e cronogramas estimados. Você pode comparar ofertas lado a lado e atribuir o projeto ao empreiteiro escolhido.',
                title3: 'Construção e Supervisão do Inspetor',
                description3: 'A construção começa no local. Seu inspetor dedicado visita pelo menos a cada 48 horas para monitorar o progresso, sinalizar defeitos e garantir conformidade com os planos aprovados. Qualquer problema é registrado como incidente em seu painel e visível para todas as partes. Você pode enviar mensagens diretamente com sua equipe a qualquer momento.',
                title4: 'Pagamentos Baseados em Etapas',
                description4: 'Você deposita o valor total da construção em uma conta bancária segura específica do projeto. Os pagamentos são liberados apenas quando uma etapa é oficialmente concluída. As etapas incluem fundação, estrutura, telhado, etc. Cada pagamento é acionado apenas quando seu arquiteto fornece um certificado atestado de conclusão, carregado diretamente na plataforma.',
                title5: 'Obtenha seu plano de construção',
                description5: 'Uma vez contratada, sua equipe de arquitetos colabora (remotamente e localmente) para criar seu design completo da casa: plantas baixas, renderizações 3D, especificações de construção e documentos legais. Você revisará e aprovará designs através do seu painel PlanNbuild, com ferramentas completas de feedback e controle de versão.',
                title6: 'Selecione sua equipe de arquitetos',
                description6: 'Navegue por equipes selecionadas consistindo de um arquiteto europeu (para sensibilidade de design internacional), um arquiteto cabo-verdiano (para conformidade com códigos locais) e um inspetor licenciado na ilha. Revise seus perfis, trabalhos anteriores, avaliações e disponibilidade — então selecione sua equipe ideal.'
            },
            footer: {
                about: 'Sobre',
                howItWorks: 'Como funciona',
                termsPrivacy: 'Termos & Privacidade',
                contactSupport: 'Contato de Suporte',
                createdWith: 'Criado com ❤️ por',
                followUsOn: 'Siga-nos no'
            },
            list: 'Lista',
            searchWithCompanyName: 'Pesquisar com nome da empresa',
            companyInformation: 'Informações da empresa',
            email: 'E-mail',
            experience: 'Experiência',
            website: 'Website',
            url: 'URL',
            about: 'Sobre',
            bio: 'Bio',
            specialties: 'Especialidades',
            active: 'Ativo',
            inactive: 'Inativo',
            staffAccounts: 'Contas de Funcionários',
            phone: 'Telefone',
            status: 'Status',
            loading: 'Carregando',
            loadingDescription: 'Aguarde enquanto buscamos os detalhes da empresa...',
            error: 'Erro',
            retry: 'Tentar novamente',
            noStaffAccounts: 'Nenhuma conta de funcionário encontrada',
            noStaffAccountsDescription: 'Esta empresa ainda não adicionou nenhum membro da equipe.',
            noResultFound: "Nenhum resultado encontrado",
        }
    },
    bn: {
        translation: {
            // ... existing translations ...
            staffAccounts: 'স্টাফ অ্যাকাউন্টস',
            phone: 'ফোন',
            status: 'স্ট্যাটাস',
            loading: 'লোড হচ্ছে',
            loadingDescription: 'অনুগ্রহ করে অপেক্ষা করুন যখন আমরা কোম্পানির বিবরণ আনছি...',
            error: 'ত্রুটি',
            retry: 'আবার চেষ্টা করুন',
            noStaffAccounts: 'কোন স্টাফ অ্যাকাউন্ট পাওয়া যায়নি',
            noStaffAccountsDescription: 'এই কোম্পানিটি এখনও কোন স্টাফ সদস্য যোগ করেনি।',
            noResultFound: "কোন ফলাফল পাওয়া যায়নি",
            // ... existing translations ...
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('language') || navigator.language.split('-')[0] || 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n; 